exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-a6237802] {\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 20px;\n}\nh3[data-v-a6237802] {\n  font-size: 18px;\n  font-weight: 500;\n  margin-top: 50px;\n}\n.btn-base[data-v-a6237802] {\n  border: solid #ffa300;\n}\n", ""]);

// exports
